import Vue from 'vue'
import VueRouter from 'vue-router'
import Templates from '../pages/Templates'
import TemplateBuilder from '../pages/TemplateBuilder'
import TemplateCreator from '../pages/TemplateCreator'
import TemplateCreatorDragAndDrop from '../pages/TemplateCreatorDragAndDrop'
import TemplateCreatorCustomCode from '../pages/TemplateCreatorCustomCode'
import TemplateSelector from '../pages/TemplateSelector'
import { TemplateDetails, TemplateDetailsSummary, TemplateDetailsPreview, TemplateDetailsTesting, TemplateDetailsCampaigns, TemplateDetailsHistory } from '../pages/TemplateDetails/'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/template-builder',
    name: 'Home',
    component: Templates
  },
  {
    path: '/template-builder',
    name: 'TemplateBuilder',
    component: TemplateBuilder
  },
  {
    path: '/template-details/',
    redirect: '/template-details/summary',
    name: 'TemplateDetails',
    component: TemplateDetails,
    meta: { page: 'details' },
    children: [
      {
        path: 'summary',
        name: 'TemplateDetailsSummary',
        component: TemplateDetailsSummary,
        meta: { page: 'details' }
      },
      {
        path: 'preview',
        name: 'TemplateDetailsPreview',
        component: TemplateDetailsPreview,
        meta: { page: 'details' }
      },
      {
        path: 'testing',
        name: 'TemplateDetailsTesting',
        component: TemplateDetailsTesting,
        meta: { page: 'details' }
      },
      {
        path: 'campaigns',
        name: 'TemplateDetailsCampaigns',
        component: TemplateDetailsCampaigns,
        meta: { page: 'details' }
      },
      {
        path: 'history',
        name: 'TemplateDetailsHistory',
        component: TemplateDetailsHistory,
        meta: { page: 'details' }
      }
    ]
  },
  {
    path: '/template-selector',
    name: 'TemplateSelector',
    component: TemplateSelector
  },
  {
    path: '/template-create',
    name: 'TemplateCreator',
    component: TemplateCreator
  },
  {
    path: '/template-create-dragAndDrop',
    name: 'TemplateCreatorDragAndDrop',
    component: TemplateCreatorDragAndDrop
  },
  {
    path: '/template-create-customCode',
    name: 'TemplateCreatorCustomCode',
    component: TemplateCreatorCustomCode
  },
  {
    path: '/template-edit/:id',
    name: 'TemplateEditor',
    component: TemplateCreator
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  window.localStorage.setItem('LS_ROUTE', to.path)
})

let isFirstTransition = true
router.beforeEach((to, from, next) => {
  let shouldRedirect = false
  const entry = performance.getEntriesByType('navigation')
  if (to.name === 'Home' && localStorage.getItem('LS_ROUTE') && isFirstTransition && entry[0].type === 'reload') {
    shouldRedirect = true
  }
  isFirstTransition = false
  if (shouldRedirect) {
    next({ path: localStorage.getItem('LS_ROUTE'), query: to.query })
  } else {
    next()
  }
})

export default router
